import { useEffect } from 'react';
import { sendAmplitudeEvent } from './amplitudeService';

const useSendAmplitudeEventOnMount = ({ eventType, eventProperties, userProperties }) => {
    useEffect(() => {
        sendAmplitudeEvent({
            eventType,
            eventProperties,
            userProperties,
        });
    }, []);
};

export default useSendAmplitudeEventOnMount;
